import { render, staticRenderFns } from "./cardMgt.vue?vue&type=template&id=33859aba&scoped=true&"
import script from "./cardMgt.vue?vue&type=script&lang=js&"
export * from "./cardMgt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33859aba",
  null
  
)

export default component.exports